import React, { useState } from 'react';
import PrefixIcon from '../../assets/images/PrefixIcon.svg';
import { Card, Col, Container, Row } from 'reactstrap';
import { dateInRequireFormate } from '../../utils/Utils';

const ServiceOrganizations = ({ serviceOrgData, onCloseClick, content }) => {
    const [openItems, setOpenItems] = useState({});

    const handleAccorShow = (idx) => {
        setOpenItems((prev) => ({
            ...prev,
            [idx]: !prev[idx] // Toggle the state of the clicked item
        }));
    };

    const textWrap = {
        wordBreak: 'break-word'
    };

    const onClickBack = () => {
        onCloseClick();
    };

    return (
        <div className="mt-2">
            <div className="d-flex align-items-center">
                <span className="me-3 cursor-pointer" onClick={onClickBack}>
                    <img src={PrefixIcon} alt="" className="text-primary" />
                </span>
                <p className="fs-5 mb-0 pt-1 text-b">{serviceOrgData?.programName}</p>
            </div>
            <div className="mt-1 ml-4">
                <p className="text-b">{content?.suggestedText} </p>
            </div>
            <div className="mt-1">
                <Row>
                    {serviceOrgData?.serviceOrganizations?.length > 0 &&
                        serviceOrgData?.serviceOrganizations?.map((org, index) => (
                            <Col lg={6} sm={12} md={12} xxl={4} xl={4} key={index} className="mb-1">
                                <Card className="p-1 rounded card-custom-bg">
                                    <div
                                        className={`d-flex justify-content-between align-items-center  pb-2  ${
                                            openItems[index] ? 'border-bottom' : ''
                                        }`}
                                        // onClick={() => handleAccorShow(index)}
                                    >
                                        <div className="text-wrap mt-2">
                                            <h6 className="m-0 fs-8  text-dark">
                                                {org?.serviceOrganizationName ? org?.serviceOrganizationName : '-'}
                                            </h6>
                                        </div>
                                        {/* <div className="d-flex align-items-center flex-shrink-0">
                                            <span className="fs-10 d-flex align-items-center">
                                                <span className="text-success">●</span>
                                                <span className="ms-1">Working Hours</span>
                                            </span>
                                            <span className="ms-2 fs-10">
                                                <i className={`ri-arrow-${openItems[index] ? 'down' : 'right'}-s-line text-dark`}></i>
                                            </span>
                                        </div> */}
                                    </div>
                                    {/* {openItems[index] && ( */}
                                    <div className="mt-1 ml-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="ri-map-pin-fill text-danger fs-3"></i>
                                                <div className="fs-6 ms-2">{org?.location ? org?.location : '-'}</div>
                                            </div>
                                            {/* <Card className="p-1">
                                                    <div className="text-success fs-10">2 miles away</div>
                                                </Card> */}
                                        </div>
                                        <div className="d-flex align-items-center mt-2">
                                            <i className="ri-phone-fill text-success fs-3"></i>
                                            <p className="fs-6 m-0 ms-2">{org?.phone ? org?.phone : '-'}</p>
                                        </div>
                                        <div className="d-flex align-items-center mt-2">
                                            <i className="ri-mail-fill text-warning fs-3"></i>
                                            <p className="fs-6 m-0 ms-2" style={textWrap}>
                                                {org?.email ? org?.email : '-'}
                                            </p>
                                        </div>
                                        <div className="d-flex align-items-center mt-2">
                                            <i className="ri-global-fill text-info fs-3"></i>
                                            <a
                                                href={org?.website?.startsWith('http') ? org?.website : `http://${org?.website}`}
                                                className="fs-6 m-0 ms-2 text-info"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={textWrap}
                                            >
                                                {org?.website ? 'Click here to visit the website' : '-'}
                                            </a>
                                        </div>
                                        <div className="d-flex align-items-center mt-2">
                                            <i className="ri-calendar-line text-success fs-3"></i>
                                            <p className="fs-6 m-0 ms-2">
                                                {org?.pcpAppointmentDate
                                                    ? dateInRequireFormate(org?.pcpAppointmentDate, 'm/d/y/hh:mm')
                                                    : '-'}
                                            </p>
                                        </div>
                                        <div className="d-flex align-items-center mt-2">
                                            <i className="ri-sticky-note-line text-info fs-3"></i>
                                            <p className="fs-6 m-0 ms-2" style={textWrap}>
                                                {org?.notes ? org?.notes : '-'}
                                            </p>
                                        </div>
                                    </div>
                                    {/* )} */}
                                </Card>
                            </Col>
                        ))}
                </Row>
            </div>
        </div>
    );
};

export default ServiceOrganizations;
